export function normalizeSecondaryEmails(secondaryEmails) {
  return Array.isArray(secondaryEmails) ? secondaryEmails : [];
}

export function buildEditMemberStateFromMember(member) {
  const user = member || {};

  return {
    id: user._id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    secondaryEmails: normalizeSecondaryEmails(user.secondaryEmails),
    phone: user.phone,
    address: user.address,
    city: user.city || "",
    zip: user.zip,
    state: user.state,
    emailStatus: user.emailStatus,
    country: user.country,
    cellular: user.cellular,
    status: user.status,
    courses: user.courses,
    subscriptions: user.subscriptions,
    pas: user.pas,
    downloads: user.downloads,
    notes: user.notes,
    tradeStationId: user.tradestationId,
    role: user.role,
    loading: false,
  };
}

export function applyEditMemberFieldChange(state, name, value) {
  return {
    ...state,
    [name]: value,
  };
}

export function updateEditMemberSecondaryEmail(state, index, field, value) {
  const secondaryEmails = normalizeSecondaryEmails(state && state.secondaryEmails).slice();
  secondaryEmails[index] = {
    ...secondaryEmails[index],
    [field]: field === "verified" ? Boolean(value) : value,
  };

  return {
    ...state,
    secondaryEmails,
  };
}

export function addEditMemberSecondaryEmail(state) {
  return {
    ...state,
    secondaryEmails: [
      ...normalizeSecondaryEmails(state && state.secondaryEmails),
      { email: "", type: "alternate", source: "admin", verified: false },
    ],
  };
}

export function removeEditMemberSecondaryEmail(state, index) {
  return {
    ...state,
    secondaryEmails: normalizeSecondaryEmails(state && state.secondaryEmails)
      .filter((_email, emailIndex) => emailIndex !== index),
  };
}
